import type { AxiosRequestConfig, AxiosResponse } from 'axios';

import client from 'api/client';
import type { MeResponse } from 'api/models/response';
import type {
    ConsultantLicense,
    ConsultantLicensePayload,
    ConsultantLicenseUpdatePayload,
} from 'types';

export function get(
    customConfig?: AxiosRequestConfig<unknown>
): Promise<AxiosResponse<MeResponse>> {
    return client.get<MeResponse>('/me', customConfig);
}

export function listLicenses(): Promise<AxiosResponse<ConsultantLicense[]>> {
    return client.get<ConsultantLicense[]>('/me/licenses');
}

export function addLicense(
    payload: ConsultantLicensePayload
): Promise<AxiosResponse<ConsultantLicense>> {
    return client.post<ConsultantLicense>('/me/licenses', payload);
}

export function updateLicense(
    licenseId: number,
    payload: ConsultantLicenseUpdatePayload
): Promise<AxiosResponse<ConsultantLicense>> {
    return client.patch<ConsultantLicense>(`/me/licenses/${licenseId}`, payload);
}

export function removeLicense(licenseId: number): Promise<AxiosResponse<void>> {
    return client.delete<void>(`/me/licenses/${licenseId}`);
}
